/* @ngInject */
function PublicationPropertiesController ($rootScope, $scope, $timeout, $translate, $q, $attrs, $element, ArtsService, GroupService, ArtCollectionsService, ToastService, UdsModalService) {
  const ARTS_GROUPS_SEGMENTATION = 'ARTS.GROUPS_SEGMENTATION'
  const ARTS_SCHEDULE_PUBLICATION = 'ARTS.SCHEDULE_ARCHIVE_TEMPLATE'
  const CURRENT_DAY = new Date().toISOString()

  const getNewGroupDialogController = () => $q.when(import('../../../admin/dialogs/new-group/new-group-dialog.controller'))

  $scope.optional = {
    instructions: false,
    terms: false,
    schedulePublication: false,
    scheduleExpiration: false
  }

  $scope.flags = {
    disabledGroups: true,
    noGroups: false,
    noLinkedTemplates: false,
    groups: {
      top: 10,
      skip: 0,
      hasMoreOptions: false,
      pricing: false
    },
    linkedTemplates: {
      top: 10,
      skip: 0,
      hasMoreOptions: false,
      show: false
    },
    schedulePublication: {
      hasCampaign: false,
      pricing: false,
      minDate: CURRENT_DAY,
      maxDate: ''
    },
    scheduleExpiration: {
      hasCampaign: false,
      minDate: CURRENT_DAY,
      maxDate: ''
    }
  }

  $scope.groups = []
  $scope.cachedGroups = []
  $scope.selectedGroups = []
  $scope.linkedTemplates = []
  $scope.selectedLinkedTemplates = []

  $scope.groupsPlaceholder = $translate.instant('selectAGroup')
  $scope.linkedTemplatesPlaceholder = $translate.instant('select')

  $scope.currentModule = ''
  $scope.campaigns = []

  $scope.isCreatingInsideCampaign = false

  $scope.stateValue = false

  const api = {
    getNewGroupDialogController,
    _getGroups,
    _successGetGroups,
    _customizeRows,
    _hasMoreResults,
    _checkPricing,
    _getCompanyTemplates,
    _successGetCompanyTemplates,
    _reloadData,
    _throwResponseError,
    _handleArtCollectionInsideCampaign,
    _handleArtCollection,
    _fillInputsWithCampaignInfo,
    _setSelectedCampaign,
    _setSchedulePublicationMinDate,
    _setSchedulePublicationMaxDate,
    _getArtCollectionIdInfo,
    _fillDateInputs,
    _setCampaignPublicationProperties
  }

  this.getApi = () => api

  activate()

  function activate () {
    $scope.unpublishedArt = !$scope.data.art?.isTemplate && $rootScope.isUserSysAdminAdminDesigner()
    $scope.currentModule = 'arts'
    $scope.isTabDisabled = (!!$scope.data.art?.campaignId || !!$scope.data.campaign?.id) && $scope.data.art?.isActiveInCampaign !== false

    api._getArtCollectionIdInfo($scope.data.artCollectionId)

    GroupService.getAllGroups().then(groups => {
      $scope.groups = api._customizeRows(groups)
      $scope.flags.linkedTemplates.show = $rootScope?.oUserCompanyFeatures?.includes('LINKED_TEMPLATES')
      api._checkPricing()

      if ($scope.flags.linkedTemplates.show) {
        return api._getCompanyTemplates(true, null, null, $scope.formProperties.linkedTemplates)
      }
    }).finally(() => {
      $scope.tabsLoadingData.publicationTab = false
      api._setSelectedCampaign()
    })

    if ($scope.data.campaign) {
      api._setCampaignPublicationProperties($scope.data.campaign)
    }
  }

  $scope.$watch('formProperties.schedulePublication', () => {
    if ($scope.formProperties.schedulePublication) {
      $scope.flags.scheduleExpiration.minDate = $scope.formProperties.schedulePublication
    }
  })

  $scope.$watch('formProperties.scheduleExpiration', () => {
    if ($scope.formProperties.scheduleExpiration) {
      $scope.flags.schedulePublication.maxDate = $scope.formProperties.scheduleExpiration
    }
  })

  $scope.$on('template-props.reload-data', () => {
    $timeout(() => {
      api._reloadData()
    })
  })

  $scope.$on('campaign-selected', (event, selectedCampaign) => {
    if (!selectedCampaign) {
      if ($scope?.data?.art?.id) {
        ArtsService.unbindTemplateFromCampaign($scope.data.art.id)
          .then(() => {
            $scope.formProperties.campaignId = null
          })
      } else {
        $scope.formProperties.campaignId = null
      }
    } else {
      $timeout(() => {
        $scope.formProperties.campaignId = selectedCampaign.id
      })
    }
  })

  $scope.toggleOptionalContainer = (event) => {
    if ($scope.data.campaign || $scope.formProperties.campaignId) {
      $timeout(() => {
        $element.find('uds-toggle[name="schedulePublication"]')[0].checked = true
      }, 50)

      ToastService.showInfoToast($translate.instant('campaignMaterialsDateWarning'))
      return
    }

    $scope.stateValue = !$scope.optional[event.detail.name]

    $scope.optional[event.detail.name] = !$scope.optional[event.detail.name]

    const checkboxes = {
      schedulePublication: () => {
        $scope.formProperties.schedulePublication = ''
      },
      scheduleExpiration: () => {
        $scope.formProperties.scheduleExpiration = ''
      }
    }

    if (checkboxes[String(event.detail.name)]) {
      checkboxes[String(event.detail.name)]()
    }
  }

  $scope.onChangeSegmentation = (event) => {
    const segmentation = event.detail.value

    if (segmentation === 'allUsers') {
      $scope.formProperties.allUsers = true
      $scope.formProperties.groups = []
      $scope.cachedGroups = []
      $scope.flags.disabledGroups = true
    } else {
      $scope.formProperties.allUsers = false
      $scope.flags.disabledGroups = false
      $scope.flags.groups.skip = 0
    }
  }

  $scope.onChangeCalendar = (event) => {
    const type = event.currentTarget.identifier
    $scope.formProperties[type] = event.detail.date
  }

  $scope.onInfiniteGroups = (event) => {
    const totalCount = event.detail?.totalCount

    $scope.flags.groups.skip = $scope.flags.groups.top + $scope.flags.groups.skip

    api._getGroups(false, totalCount)
  }

  $scope.onChangeGroups = (event) => {
    const cachedGroups = event.detail

    $scope.cachedGroups = cachedGroups
    $scope.formProperties.groups = cachedGroups.map(group => group.value)
  }

  $scope.onSearchGroups = (event) => {
    const totalCount = event.detail?.totalCount
    const search = event.detail?.search || ''
    $scope.flags.groups.skip = 0

    api._getGroups(false, totalCount, search)
  }

  $scope.onInfiniteLinkedTemplates = (event) => {
    const totalCount = event.detail?.totalCount
    const search = event.detail?.search || ''

    $scope.flags.linkedTemplates.skip = $scope.flags.linkedTemplates.top + $scope.flags.linkedTemplates.skip

    api._getCompanyTemplates(false, totalCount, search)
  }

  $scope.onChangeLinkedTemplates = (event) => {
    const linkedTemplates = event.detail

    $scope.formProperties.linkedTemplates = linkedTemplates.map(linkedTemplate => linkedTemplate.id)
  }

  $scope.onSearchLinkedTemplates = (event) => {
    const totalCount = event.detail?.totalCount
    const search = event.detail?.search || ''
    $scope.flags.linkedTemplates.skip = 0

    api._getCompanyTemplates(false, totalCount, search)
  }

  $scope.onClickPricing = (type) => {
    const types = {
      segmentGroups: {
        featureName: $translate.instant('billingFeatures.artsGroupsSegmentation'),
        featureSlug: ARTS_GROUPS_SEGMENTATION
      },
      schedulePublication: {
        featureName: $translate.instant('billingFeatures.artsScheduleArchiveTemplate'),
        featureSlug: ARTS_SCHEDULE_PUBLICATION
      }
    }

    const modalData = types[String(type)]

    if (!$scope.features[String(modalData.featureSlug)]) {
      $scope.openUpgradeCompanyPlanDialog({
        modalData
      })
    }
  }

  $scope.openCreateGroupDialog = () => {
    const groupsElement = $attrs.$$element.find('.groups-field uds-input-multiselect')[0]

    api.getNewGroupDialogController().then(({ NewGroupDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: NewGroupDialogController,
        modalName: 'newGroupDialog',
        onClose: () => {
          $scope.flags.groups.skip = 0
          groupsElement.clearComponentData()

          $timeout(() => {
            groupsElement.value = $scope.selectedGroups
          })

          api._getGroups(false, null)
        }
      })
      modal.open()
    })
  }

  $scope.handleCampaignChange = (campaign) => {
    $scope.formProperties.groups = []
    $scope.formProperties.scheduleExpiration = null
    $scope.formProperties.schedulePublication = null

    $('uds-radio-group[name="segmentation"]').attr('value', 'allUsers')
    $('.groups-field uds-input-multiselect').attr('value', [])

    $scope.isTabDisabled = !!campaign
    api._fillInputsWithCampaignInfo(campaign)
    api._setCampaignPublicationProperties(campaign)
  }

  $scope.getCurrentCampaignId = () => {
    if ($scope.data.art?.isActiveInCampaign === false) {
      return null
    }

    return $scope.data.art?.campaignId || $scope.data.campaign?.id
  }

  function _getGroups (firstLoading, totalCount, search = '', groupsIds) {
    const iTop = $scope.flags.groups.top
    const iSkip = $scope.flags.groups.skip
    const sSearchTerm = {
      searchTerm: search
    }
    const bSimplified = null
    const isAnalytics = null

    return GroupService.getGroups(
      iTop,
      iSkip,
      sSearchTerm,
      bSimplified,
      isAnalytics,
      groupsIds
    ).then(response => api._successGetGroups(response, firstLoading, totalCount, groupsIds)).catch(api._throwResponseError)
  }

  function _successGetGroups (response, firstLoading, totalCount, groupsIds) {
    if (firstLoading && !response.d.results.length) {
      $scope.flags.noGroups = true
      return
    }

    $scope.flags.noGroups = false
    $scope.groups = api._customizeRows(response.d.results)
    $scope.flags.groups.hasMoreOptions = api._hasMoreResults(response.d.__count, totalCount)

    if (groupsIds?.length) {
      $scope.selectedGroups = api._customizeRows(response.d.results)
    }
  }

  function _customizeRows (rows) {
    if (!rows?.length) {
      return []
    }

    return rows.map(row => {
      return {
        ...row,
        label: row.name,
        value: row.id
      }
    })
  }

  function _hasMoreResults (totalCount, responseLength) {
    if (!responseLength) {
      return true
    }

    return totalCount > responseLength
  }

  function _checkPricing () {
    if (!$scope.features[ARTS_GROUPS_SEGMENTATION]) {
      $scope.formProperties.allUsers = true
      $scope.flags.groups.pricing = true
      $scope.flags.disabledGroups = true
    }

    if (!$scope.features[ARTS_SCHEDULE_PUBLICATION]) {
      $scope.flags.schedulePublication.pricing = true
    }
  }

  function _getCompanyTemplates (firstLoading, totalCount, search, templatesIds) {
    const top = $scope.flags.linkedTemplates.top
    const skip = $scope.flags.linkedTemplates.skip
    const sort = null
    const startFromId = null
    const previewSort = null

    ArtsService.getCompanyTemplates(
      top,
      skip,
      null,
      sort,
      search,
      startFromId,
      previewSort,
      templatesIds
    )
      .then(response => api._successGetCompanyTemplates(firstLoading, response, totalCount, templatesIds))
      .catch(api._throwResponseError)
  }

  function _successGetCompanyTemplates (firstLoading, response, totalCount, templatesIds) {
    if (firstLoading && !response.d.results.length) {
      $scope.flags.noLinkedTemplates = true
      return
    }

    $scope.flags.noLinkedTemplates = false
    $scope.linkedTemplates = api._customizeRows(response.d.results)
    $scope.flags.linkedTemplates.hasMoreOptions = api._hasMoreResults(response.d.__count, totalCount)

    const hasLinkedTemplate = $scope.linkedTemplates.find(linkedTemplate => {
      const hasLinkedTemplate = $scope.formProperties.linkedTemplates.some(formLinkedTemplate => formLinkedTemplate === linkedTemplate.id)

      if (hasLinkedTemplate) {
        return linkedTemplate
      }

      return null
    })

    if (hasLinkedTemplate) {
      $scope.selectedLinkedTemplates.push(hasLinkedTemplate)
      return
    }

    if (templatesIds?.length) {
      $scope.selectedLinkedTemplates = api._customizeRows(response.d.results)
    }
  }

  function _reloadData () {
    if ($scope.formProperties?.groups?.length) {
      $scope.flags.disabledGroups = false

      const selectedGroups = $scope.groups.reduce((arr, group) => {
        const hasGroup = $scope.formProperties.groups.some(formGroup => formGroup === group.value)

        if (hasGroup) {
          arr.push(group)
        }

        return arr
      }, [])

      if (selectedGroups.length) {
        $scope.selectedGroups.push(...selectedGroups)
      }
    }

    if ($scope.formProperties.schedulePublication) {
      $scope.optional.schedulePublication = true
    }

    if ($scope.formProperties.scheduleExpiration) {
      $scope.optional.scheduleExpiration = true
    }
  }

  function _throwResponseError (error) {
    console.log({ error })
    ToastService.defaultErrorToast()
  }
  function _getArtCollectionIdInfo (artCollectionId) {
    if (!artCollectionId) return

    $q.all([
      ArtCollectionsService.isArtCollectionInsideCampaign(artCollectionId),
      ArtCollectionsService.find(artCollectionId)
    ])
      .then(([response, collection]) => {
        if (response.isInsideCampaign) {
          api._handleArtCollectionInsideCampaign(response)
        }
        if (collection) {
          api._handleArtCollection(collection)
        }

        api._fillDateInputs(response.campaign, collection)
      })
  }

  function _handleArtCollectionInsideCampaign (response) {
    $scope.selectedCampaign = {
      id: response.collection.campaignId,
      value: response.collection.campaignId,
      label: response.collection.campaignTitle,
      startDate: response.campaign.startDate,
      deliveryDate: response.campaign.deliveryDate,
      expireCampaignContentsOnFinish: response.campaign.expireCampaignContentsOnFinish
    }

    $scope.formProperties.campaignId = response.collection.campaignId
    $scope.isCreatingInsideCampaign = true

    api._fillInputsWithCampaignInfo({ info: response.campaign })
  }

  function _handleArtCollection (collection) {
    const isSegmentedOrScheduled = collection.scheduledDate || collection.expirationDate || collection.collectionGroups.length > 0
    const isNotInActiveCampaign = collection.isActiveInCampaign === false || collection.campaignId === null
    $scope.collectionIsSegmentedOrScheduled = isSegmentedOrScheduled && isNotInActiveCampaign
  }

  function _fillInputsWithCampaignInfo (campaign) {
    $scope.optional.scheduleExpiration = true
    $scope.optional.schedulePublication = true
    $scope.formProperties.allUsers = !campaign.info.groups?.length
    $scope.formProperties.groups = campaign.info.groups?.map(group => group.id) || []
    $scope.selectedGroups = api._customizeRows(campaign.info.groups)
  }

  function _fillDateInputs (campaign, collection) {
    if (!campaign) {
      api._setSchedulePublicationMinDate(null)
      api._setSchedulePublicationMaxDate(null)
      return
    }

    let startDate = moment(campaign.startDate)
    let deliveryDate

    if (campaign.expireCampaignContentsOnFinish) {
      deliveryDate = moment(campaign.deliveryDate)
    }

    if (collection?.scheduledDate) {
      startDate = moment(collection.scheduledDate)
    }

    if (collection?.expirationDate) {
      deliveryDate = moment(collection.expirationDate)
    }

    $scope.formProperties.scheduleExpiration = deliveryDate
    $scope.formProperties.schedulePublication = startDate

    api._setSchedulePublicationMinDate(startDate)
    api._setSchedulePublicationMaxDate(deliveryDate)
  }

  function _setSelectedCampaign () {
    $scope.hasDefaultCampaign = Boolean($scope.data.campaign)
    if (!$scope.data.campaign) return

    $timeout(() => {
      api._fillInputsWithCampaignInfo({ info: $scope.data.campaign })
      api._setCampaignPublicationProperties($scope.data.campaign)
    }, 500, false)
  }

  function _setSchedulePublicationMinDate (startDate) {
    if (startDate) {
      const date = new Date(startDate)
      date.setDate(date.getDate() - 1)
      $scope.flags.schedulePublication.minDate = date.toISOString()
    } else {
      $scope.flags.schedulePublication.minDate = CURRENT_DAY
    }
  }

  function _setSchedulePublicationMaxDate (deliveryDate) {
    if (deliveryDate) {
      $scope.flags.schedulePublication.maxDate = new Date(deliveryDate).toISOString()
    } else {
      $scope.flags.schedulePublication.maxDate = ''
    }
  }

  function _setCampaignPublicationProperties (campaign) {
    const campaignData = {
      schedulePublication: campaign.startDate || campaign.info.startDate
    }

    if (campaign?.expireCampaignContentsOnFinish || campaign?.info?.expireCampaignContentsOnFinish) {
      campaignData.scheduleExpiration = campaign.deliveryDate || campaign.info.deliveryDate
    }
    $scope.formProperties = {
      ...$scope.formProperties,
      ...campaignData

    }
    $scope.optional = {
      ...$scope.optional,
      schedulePublication: true,
      scheduleExpiration: true
    }
    $scope.flags = {
      ...$scope.flags,
      schedulePublication: {
        ...$scope.flags.schedulePublication
      },
      scheduleExpiration: {
        ...$scope.flags.scheduleExpiration
      }
    }
    $scope.selectedGroups = api._customizeRows(campaign.groups)
  }
}

export { PublicationPropertiesController }
